















































import { Vue, Component } from 'vue-property-decorator'
import { Scroller } from '@lx-frontend/cvux'
import util from '../../common/util'
import TabList from '../components/TabList.vue'

@Component({
  components: {
    Scroller,
    TabList
  }
})
export default class Index extends Vue {
  dataNumberList = []

  totalCount: number = 0

  tabList = [
    { key: 1, name: '待用餐' },
    { key: 2, name: '已用餐' },
    { key: 3, name: '已取消' }
  ]

  tabStatus = 1
  list: Object[] = []

  search() {
    this.getData()
  }

  async mounted() {
    this.getData()
  }

  getData() {
    (this as any).switchLoading({ status: true, text: '加载中...' })
    this.$rest.tool.getMealNumbers({ status: +this.tabStatus }).then(res => {
      if (res.code === 0) {
        this.dataNumberList = res.data || []
        this.totalCount = this.dataNumberList.length
        this.dataNumberList.forEach((v: any, i) => {
          const val = String(v.number_range).split('-')
          v.number_range = val[0] === val[1] ? '' : v.number_range
        })
      } else {
        util.showToast(res.message)
      }
      (this as any).switchLoading({ status: false })
    })
  }

  async handleSentGuestMethod(name: string) {
    let list: Array<number> = []
    const api: any = {
      'notice': 'getMealNotice',
      'dined': 'getMealDined'
    }
    this.dataNumberList.filter((v: any) => {
      if (v.choice) {
        list = [...list, v.id]
      }
    })
    if (list.length < 1) {
      util.showToast('请选择需要操作的号码')
      return
    }
    const { code, res } = await (this.$rest.tool as any)[api[name]]({
      number_ids: list
    })
    if (code !== 0) {
      util.showToast(res.message)
      this.getData()
    }
    util.showToast('操作成功')
    this.getData()
  }

  handleChoiceNumber(item: any) {
    this.dataNumberList.filter((v: any) => {
      v.choice = v.number === item.number ? !v.choice : v.choice
    })
  }

  tabSwitch(key: number) {
    this.tabStatus = key
  }
}
